import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  text: {
    fontSize: '20px',
    fontWeight: '600',
    lineHeight: '24.2px',
    fontFamily:'Roboto',
  },
}));

const InformationText = ({ value, style, symbol }) => {
  const classes = useStyles();
  // show the value and symbol if it exists
  const displayValue = symbol ? `${value} ${symbol}` : value;
  return <div className={classes.text} style={{...style}}>{displayValue}</div>;
};

export default InformationText;
